import { FC, PropsWithChildren, useCallback, useRef } from 'react';

import { AsyncPage } from '@/components';

const PrivateView: FC<PropsWithChildren> = ({ children }) => {
	const routeIsInitialized = useRef(false);

	const fetchData = useCallback(async () => {
		if (routeIsInitialized.current) {
			return;
		}

		// on route checks go here

		routeIsInitialized.current = true;
	}, []);

	return <AsyncPage fetchData={fetchData}>{children}</AsyncPage>;
};

export const PrivateRoute: FC<PropsWithChildren> = ({ children }) => {
	return <PrivateView>{children}</PrivateView>;
};
